import React, { useCallback } from 'react';
import { Select } from 'antd';

const { Option } = Select;
import { Flex } from 'rebass';
import styled from 'styled-components';
import Label from '../../label';
import { useQuery } from '@apollo/react-hooks';
import countriesQuery from 'graphql/countries/all-query.graphql';
import { useSelector, useStore } from 'react-redux';
import { selectCountryId, userSlice } from '../../../store/user';

const StyledCountryImage = styled.img`
  width: 30px;
  border-radius: 6px;
`;
const { updateCountry } = userSlice.actions;

export function Countries() {
  const store = useStore();
  const { data, loading } = useQuery(countriesQuery);
  const countryId = useSelector(selectCountryId);
  
  const skipDeletedFromData = [];
  data?.countries?.map((country)=>{
    if(country?.status !== 'DELETED'){
      skipDeletedFromData.push(country)
    }
  });
  
  const handleCountryChange = useCallback(
    countryId => {
      const country = data.countries.find(({ id }) => id === countryId);
      store.dispatch(updateCountry(country));
    },
    [data?.countries, store]
  );

  return (
    <Flex px={2} className={!countryId && 'ant-form-item-has-error'}>
      <Select
        bordered={false}
        loading={loading}
        placeholder="Select Country"
        value={loading ? undefined : countryId}
        onChange={handleCountryChange}
        defaultActiveFirstOption
      >
        {skipDeletedFromData.map(country => (
          <Option key={country.id} value={country.id}>
            <Flex p={2} alignItems="center" height="100%">
              <StyledCountryImage alt="flag" src={country.flagPhoto} />
              {
              (country.status==="INACTIVE")?
                <Label
                  ml={2}
                  style={{opacity:0.5}}
                >
                {country.isoCode}</Label>
              :
                <Label
                  ml={2}
                  style={{fontWeight:700}}
                >
                {country.isoCode}</Label>
              }
            </Flex>
          </Option>
        ))}
      </Select>
    </Flex>
  );
}
